import { IStudioState } from './model';

export const StudioInitState: IStudioState = {
  selectStudio: null,
  studioList: [],
  studioCert: {},
};
